module.exports = {
    "breadcrumbs": `Broodkruimels`
};


//# sourceMappingURL=nl-NL.main.js.map
